/**
 * @generated SignedSource<<d822ce1045bddbc8b6555a2dac94a16b>>
 * @flow
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

/*::
import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentType } from "relay-runtime";
declare export opaque type Tag_tag$fragmentType: FragmentType;
export type Tag_tag$data = {|
  +label: string,
  +$fragmentType: Tag_tag$fragmentType,
|};
export type Tag_tag$key = {
  +$data?: Tag_tag$data,
  +$fragmentSpreads: Tag_tag$fragmentType,
  ...
};
*/

var node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Tag_tag",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "label",
      "storageKey": null
    }
  ],
  "type": "PipelineTag",
  "abstractKey": null
};

(node/*: any*/).hash = "bc8a9a38b5cf8cb381d0ad2c9fb8acc9";

module.exports = ((node/*: any*/)/*: Fragment<
  Tag_tag$fragmentType,
  Tag_tag$data,
>*/);
